import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Plus, Eye, Pencil, Trash2, Search, FileText, File, Image as ImageIcon } from "lucide-react";
import { CgCloseR } from "react-icons/cg";
import { FaSearch, FaFilePdf } from "react-icons/fa";
import { GrStatusInfo } from "react-icons/gr";
import { AiOutlineSortAscending } from "react-icons/ai";
import Loading from "../../component/Loading/Loading";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import useAxiosInstance from "../../services/useAxiosInstance";
import { useSelector } from "react-redux";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";
import Pagination from '../../utils/Pagenation/Pagenation';

const ServiceRequest = () => {
    const [clearBtnshow, setClearBtnshow] = useState(false);
    const axiosInstance = useAxiosInstance();
    const [serviceRequests, setServiceRequests] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [serviceRequestStatus, setServiceRequestStatus] = useState([]);
    console.log(serviceRequestStatus);

    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    const [userName, setUserName] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedServiceRequest, setSelectedServiceRequest] = useState(null);
    const [sid, setSid] = useState(null);

    console.log(selectedServiceRequest);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [serviceRequestToDelete, setServiceRequestToDelete] = useState(null);
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const clinetId = useSelector((state) => state.auth.clientId);

    const currentDate = new Date().toISOString();
    const roleId = useSelector((state) => state.auth.roleId);

    const [serviceRequestData, setServiceRequestData] = useState({
        authenticationCode: "",
        communityId: communityId,
        createdById: userId,
        createdDate: currentDate,
        description: "",
        invoiceNo: "",
        docUrl: "",
        modifiedById: null,
        modifiedDate: currentDate,
        requestedClientId: roleId === 1003 ? String(clinetId) : "0",
        requiredDate: "",
        serviceCharge: 0,
        serviceRequestId: 0,
        serviceRequestStatusId: 58117,
        serviceTypeId: 0,
        vendorAccessCode: "",
        vendorId: null,
    });

    console.log(serviceRequestData);
    const [clients, setClients] = useState([]);

    // Helper function to detect file type and get appropriate display
    const getFileDisplay = (fileUrl) => {
        if (!fileUrl) return null;

        // Extract filename from URL
        const urlParts = fileUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
        const fileExtension = fileName.split('.').pop()?.toLowerCase();

        // Define image extensions
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];

        const isImage = imageExtensions.includes(fileExtension);

        if (isImage) {
            return {
                type: 'image',
                element: (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="block">
                        <img
                            src={fileUrl}
                            alt="Document thumbnail"
                            className="w-20 h-20 object-cover border rounded cursor-pointer hover:opacity-80 transition-opacity"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                            }}
                        />
                        <div className="hidden w-20 h-20 border rounded flex items-center justify-center bg-gray-100">
                            <ImageIcon size={24} className="text-gray-500" />
                            <span className="text-xs text-gray-500 ml-1">IMG</span>
                        </div>
                    </a>
                )
            };
        } else {
            // For non-image files, show appropriate icon and filename
            let icon;
            let label;

            switch (fileExtension) {
                case 'pdf':
                    icon = <FaFilePdf size={24} className="text-red-500" />;
                    label = 'PDF';
                    break;
                case 'doc':
                case 'docx':
                    icon = <FileText size={24} className="text-blue-500" />;
                    label = 'DOC';
                    break;
                case 'txt':
                    icon = <FileText size={24} className="text-gray-500" />;
                    label = 'TXT';
                    break;
                default:
                    icon = <File size={24} className="text-gray-500" />;
                    label = fileExtension?.toUpperCase() || 'FILE';
            }

            return {
                type: 'document',
                element: (
                    <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-20 h-20 border rounded flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
                    >
                        {icon}
                        <span className="text-xs text-gray-600 mt-1 text-center leading-tight">
                            {label}
                        </span>
                    </a>
                )
            };
        }
    };

    useEffect(() => {
        if (!communityId) return;

        const fetchClients = async () => {
            try {
                const response = await axiosInstance.get(`/api/user/getUsersList/${communityId}`);
                if (response.status === 200) {
                    const activeUsers = response.data.filter(user => user.activeStatus === true || user.activeStatus === "true");
                    console.log(response.data);
                    console.log("Filtered active users:", activeUsers);
                    setClients(activeUsers);
                } else {
                    throw new Error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };

        fetchClients();
    }, [communityId]);

    const [serviceRequestErrors, setServiceRequestErrors] = useState({});
    const communityIds = useSelector((state) => state.auth.communityId);
    const userIds = useSelector((state) => state.auth.userId);
    console.log(communityIds, userIds);
    const communityIdget = communityIds;

    let requestedClientIdget;
    if (roleId === 1001 || roleId === 1002) {
        requestedClientIdget = 0;
    } else if (roleId === 1003) {
        requestedClientIdget = clinetId;
    }
    console.log(requestedClientIdget);
    console.log(communityIds, requestedClientIdget);

    const formatDate = (date) => {
        const d = new Date(date);
        const month = '' + (d.getMonth() + 1);
        const day = '' + d.getDate();
        const year = d.getFullYear();

        return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getNextSeventhDate = () => {
        const today = new Date();
        const nextSeventhDate = new Date(today);
        nextSeventhDate.setDate(today.getDate() + 7);
        return nextSeventhDate.toISOString().split('T')[0];
    };

    const today = formatDate(new Date());
    const [startDate, setStartDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState(getNextSeventhDate());
    const [serviceRequestStatusIds, setserviceRequestStatusIds] = useState(0);

    const fetchServiceRequestData = async () => {
        setLoading(true);
        console.log('h');
        try {
            const response = await axiosInstance.get(
                `/api/public/servicerequest/CommunityIdAndCreatedById`,
                {
                    params: {
                        requestedClientId: requestedClientIdget,
                        communityId: communityIdget,
                        endDate: endDate,
                        startDate: startDate,
                        serviceRequestStatusId: serviceRequestStatusIds,
                    }
                }
            );
            console.log('dsa');
            setServiceRequests(response.data);
            console.log("Service Requests, with dates:", response.data);
        } catch (error) {
            console.error("Error fetching Service Requests:", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };

    const [filterData, setFilterData] = useState({
        startDates: getTodayDate(),
        endDates: getNextSeventhDate(),
        serviceRequestStatusIdss: 0
    });

    console.log(filterData);

    const handleStartDateChange = (event) => {
        const newStartDate = event.target.value;
        setFilterData(prev => ({
            ...prev,
            startDates: newStartDate,
            endDates: (prev.endDates && newStartDate > prev.endDates) ? '' : prev.endDates
        }));
    };

    const handleEndDateChange = (event) => {
        setFilterData({
            ...filterData,
            endDates: event.target.value
        });
    };

    const handleServiceRequestStatusIdChange = (event) => {
        setFilterData({
            ...filterData,
            serviceRequestStatusIdss: event.target.value
        });
    };

    const handleSearch = () => {
        setStartDate(filterData.startDates);
        setEndDate(filterData.endDates);
        setserviceRequestStatusIds(filterData.serviceRequestStatusIdss);
        setCurrentPage(0);
        setClearBtnshow(true);
    };

    console.log(filterData);
    const clearFilters = () => {
        setStartDate(getTodayDate());
        setEndDate(getNextSeventhDate());
        setserviceRequestStatusIds(0);
        setSearchName('');
        setFilterData({
            startDates: getTodayDate(),
            endDates: getNextSeventhDate(),
            serviceRequestStatusIds: 0
        });
        setCurrentPage(0);
        setClearBtnshow(false);
    };

    useEffect(() => {
        fetchServiceRequestData();
    }, [communityIdget, requestedClientIdget, startDate, endDate, serviceRequestStatusIds]);

    useEffect(() => {
        axiosInstance
            .get(`/api/public/servicetype/getAll`)
            .then((response) => {
                const activeServices = response.data.filter(
                    (service) => service.activestatus === true
                );
                setServiceTypes(activeServices);
            })
            .catch((error) => {
                console.error("Error fetching service types:", error);
            });
    }, []);

    useEffect(() => {
        const fetchServiceRequestStatus = async () => {
            try {
                const response = await axiosInstance.get(`/api/serviceRequestStatus/getAll`);
                setServiceRequestStatus(response.data);
            } catch (error) {
                console.error("Error fetching Service Request Status:", error);
            }
        };

        fetchServiceRequestStatus();
    }, []);

    const formattedDate = (date) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(date).toLocaleDateString(undefined, options);
    };

    const handleAddFormToggle = () => {
        setShowAddForm(!showAddForm);
        clearForm();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "requiredDate") {
            const fullDate = new Date(value).toISOString();
            setServiceRequestData({
                ...serviceRequestData,
                [name]: fullDate,
            });
        } else {
            setServiceRequestData({
                ...serviceRequestData,
                [name]: value,
            });
        }
        setSelectedStatus(e.target.value);
    };

    const validateForm = () => {
        const errors = {};
        if (!serviceRequestData.requestedClientId)
            errors.requestedClientId = "Select Client";
        if (!serviceRequestData.serviceTypeId)
            errors.serviceTypeId = "Service Request Type is required";
        if (!serviceRequestData.description)
            errors.description = "Description is required";
        if (!serviceRequestData.requiredDate)
            errors.requiredDate = "Required Date is required";
        setServiceRequestErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSubmit = async (e) => {
        console.log("start");
        setLoading(true);
        e.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            handleAddFormToggle(false);
            let newDocUrl = serviceRequestData.docUrl;
            if (selectedFile) {
                console.log("ss");
                const uploadFormData = new FormData();
                uploadFormData.append('file', selectedFile)

                try {
                    const uploadResponse = await axiosInstance.post(
                        `/api/violationDocument/violationUpload`,
                        uploadFormData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    }
                    );
                    newDocUrl = uploadResponse.data;
                    console.log(newDocUrl);
                } catch (error) {
                    console.error('Error uploading file', error);
                    return;
                }
            }
            try {
                const updatedServiceRequestData = {
                    ...serviceRequestData,
                    docUrl: newDocUrl,
                };
                console.log(updatedServiceRequestData);

                const response = await axiosInstance.post(
                    `/api/public/servicerequest/add`,
                    updatedServiceRequestData
                );
                console.log("Service request submitted successfully:", response.data);

                setAlert({ visible: true, message: 'Service request submitted successfully!', type: 'success' });
                fetchServiceRequestData();
                handleAddFormToggle();
            } catch (error) {
                setAlert({ visible: true, message: 'Error submitting service request. Please try again.', type: 'error' });
                console.error("Error submitting service request:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const clearForm = () => {
        setServiceRequestData({
            authenticationCode: "",
            communityId: communityId,
            createdById: userId,
            createdDate: currentDate,
            description: "",
            invoiceNo: "",
            paymentStatus: "",
            modifiedById: null,
            modifiedDate: currentDate,
            requestedClientId: roleId === 1003 ? String(clinetId) : "0",
            requiredDate: "",
            serviceCharge: 0,
            serviceRequestId: 0,
            serviceRequestStatusId: "58117",
            serviceTypeId: 0,
            vendorAccessCode: "",
            vendorId: null,
        });
        setServiceRequestErrors({});
    };

    const handleCancelClick = () => {
        clearForm();
        setShowAddForm(false);
    };

    const fetchServiceRequestDetails = async (serviceRequestId) => {
        setLoading(true);
        try {
            const serviceRequestResponse = await axiosInstance.get(
                `/api/public/servicerequest/getByServiceRequestId/${serviceRequestId}`
            );

            setSelectedServiceRequest(serviceRequestResponse.data);
            console.log("get one service request", serviceRequestResponse.data);

            if (
                serviceRequestResponse.data.clientUser &&
                serviceRequestResponse.data.clientUser.userId
            ) {
                const userId = serviceRequestResponse.data.clientUser.userId;
                const userResponse = await axiosInstance.get(
                    `/api/user/firstName/${userId}`
                );
                console.log("User Details:", userResponse.data);
                setUserName(userResponse.data.firstName);
            } else {
                console.error(
                    "clientUser or userId is undefined in service request data"
                );
            }
        } catch (error) {
            console.error("Error fetching service request details:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewIconClick = (serviceRequestId) => {
        fetchServiceRequestDetails(serviceRequestId);
    };

    const handleEditIconClick = (serviceRequestId) => {
        const serviceRequest = serviceRequests.find(
            (item) => item.serviceRequestId === serviceRequestId
        );

        setServiceRequestData({
            ...serviceRequest,
            modifiedDate: currentDate,
            modifiedById: userId,
        });
        setSid(serviceRequest.serviceRequestStatusId);
        setShowEditForm(true);
    };

    const [paymentFormData, setPaymentFormData] = useState({
        amenityBookingId: null,
        amount: 0,
        clientId: 0,
        communityId: 0,
        createdById: userId,
        createdDate: new Date().toISOString(),
        isApproved: true,
        modifiedById: null,
        modifiedDate: new Date().toISOString(),
        monthlyRevenueId: null,
        paymentBank: "",
        paymentDate: "",
        paymentDetailId: null,
        paymentMethod: "",
        paymentStatus: "",
        paymentType: "",
        reason: "Service Request",
        serviceRequestId: 0,
        violationId: null
    });

    const handleEditSubmit = async (e) => {
        setShowEditForm(false);
        setLoading(true);
        e.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            try {
                const response = await axiosInstance.put(
                    `/api/public/servicerequest/update`,
                    serviceRequestData);
                console.log("Service request updated successfully:", response.data);
                fetchServiceRequestData();
                setAlert({ visible: true, message: 'Service request updated successfully!', type: 'success' });

                setShowEditForm(false);
                setSid(null);
                if (response.data.serviceRequestStatusId === 69471) {
                    console.log('start-pay1');

                    const updatedPaymentFormData = {
                        ...paymentFormData,
                        serviceRequestId: response.data.serviceRequestId,
                        amount: response.data.serviceCharge,
                        clientId: response.data.requestedClientId,
                        communityId: response.data.communityId
                    };

                    console.log('ok', updatedPaymentFormData);

                    const paymentResponse = await axiosInstance.post(
                        `/api/public/paymentdetail/add`,
                        updatedPaymentFormData);

                    if (paymentResponse.status === 201) {
                        setAlert({ visible: true, message: 'Payment details added successfully!', type: 'success' });
                        console.log(updatedPaymentFormData);
                    } else {
                        setAlert({ visible: true, message: 'Failed to add payment details.', type: 'error' });
                        console.log(updatedPaymentFormData);
                    }
                }

            } catch (error) {
                console.error("Error updating service request:", error);
                setAlert({ visible: true, message: 'Error updating service request. Please try again:', type: 'error' });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDeleteIconClick = (serviceRequestId) => {
        setServiceRequestToDelete(serviceRequestId);
        setShowDeleteConfirm(true);
    };

    const handleDeleteConfirm = async () => {
        setShowDeleteConfirm(false);
        setLoading(true);
        if (serviceRequestToDelete) {
            try {
                await axiosInstance.delete(
                    `/api/public/servicerequest/delete/${serviceRequestToDelete}`);
                fetchServiceRequestData();
                setServiceRequestToDelete(null);
                setShowDeleteConfirm(false);
                setAlert({ visible: true, message: 'Service request deleted successfully!', type: 'success' });
            } catch (error) {
                console.error("Error deleting service request:", error);
                setAlert({ visible: true, message: 'Error deleting service request: Please try again.', type: 'error' });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDeleteCancel = () => {
        setServiceRequestToDelete(null);
        setShowDeleteConfirm(false);
    };

    const [searchName, setSearchName] = useState("");
    const handleSearchChange = (event) => {
        setSearchName(event.target.value);
        setCurrentPage(0);
        setClearBtnshow(true);
    };

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    const [sortColumn, setSortColumn] = useState('none');
    const [sortOrder, setSortOrder] = useState('asc');

    const handleSort = (column) => {
        const newSortOrder = (column === sortColumn && sortOrder === 'asc') ? 'desc' : 'asc';
        setSortColumn(column);
        setSortOrder(newSortOrder);
    };

    const sortedServiceRequests = [...serviceRequests].sort((a, b) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];

        if (typeof aValue === 'string') {
            return sortOrder === 'asc'
                ? aValue.localeCompare(bValue, undefined, { sensitivity: 'base' })
                : bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
        }

        return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });

    const filteredServiceRequests = sortedServiceRequests.filter((request) => {
        const nameMatch = request.serviceTypeName.toLowerCase().includes(searchName.toLowerCase());
        const clientNameMatch = request.requestedClientName.toLowerCase().includes(searchName.toLowerCase());
        const clientAddressMatch = request.requestedClientAddress.toLowerCase().includes(searchName.toLowerCase());
        const authenticationCodeMatch = request.authenticationCode.toLowerCase().includes(searchName.toLowerCase());
        const vendorAccessCode = request.vendorAccessCode.toLowerCase().includes(searchName.toLowerCase());

        return nameMatch || clientNameMatch || clientAddressMatch || authenticationCodeMatch || vendorAccessCode;
    });

    const pageCount = Math.ceil(filteredServiceRequests.length / itemsPerPage);
    const mergedFilteredDatas = filteredServiceRequests.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const [statuses, setStatuses] = useState([]);
    useEffect(() => {
        const fetchServiceRequestStatus = async () => {
            try {
                const responseStatuses = await axiosInstance.get(
                    `/api/serviceRequestStatus/getAll`
                );
                setStatuses(responseStatuses.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchServiceRequestStatus();
    }, []);

    // Add Modal Footer components
    const addModalFooter = (
        <div className="flex justify-end space-x-3">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={handleCancelClick}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );

    // Edit Modal Footer
    const editModalFooter = (
        <div className="flex justify-end space-x-3">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={() => setShowEditForm(false)}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleEditSubmit}
            >
                Update
            </button>
        </div>
    );

    // View Modal Footer
    const viewModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={() => setSelectedServiceRequest(null)}
            >
                Close
            </button>
        </div>
    );

    // Delete Modal Footer
    const deleteModalFooter = (
        <div className="flex justify-end space-x-3">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={handleDeleteCancel}
            >
                No
            </button>
            <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={handleDeleteConfirm}
            >
                Yes
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen p-2 md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="overflow-hidden flex flex-col">
                        <div className="flex justify-between items-center mb-6">
                            <h1 className="text-2xl font-bold text-gray-800">Service Request</h1>
                            <div className="flex items-center">
                                <button
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                    onClick={handleAddFormToggle}
                                >
                                    <Plus size={18} />
                                    <span>Add <span className="hidden md:inline">Request</span></span>
                                </button>
                            </div>
                        </div>
                        <div className="bg-white rounded-lg shadow-sm flex flex-wrap md:flex-nowrap justify-between items-center p-4 ">
                            <div className="relative w-full md:w-80 mb-2 md:mb-0">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <Search className="h-5 w-5 text-gray-400" />
                                </div>
                                <input
                                    type="text"
                                    id="searchName"
                                    value={searchName}
                                    onChange={handleSearchChange}
                                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Search by service request..."
                                />
                            </div>
                            <div className="flex flex-wrap gap-2 justify-between md:justify-normal w-full md:w-auto">
                                <input
                                    type="date"
                                    name="startDates"
                                    value={filterData.startDates}
                                    onChange={handleStartDateChange}
                                    max={filterData.endDates || ''}
                                    className="w-fit border border-gray-300 rounded-md px-2 md:px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <input
                                    type="date"
                                    name="endDates"
                                    value={filterData.endDates}
                                    onChange={handleEndDateChange}
                                    min={filterData.startDates || new Date().toISOString().split('T')[0]}
                                    className="w-fit  border border-gray-300 rounded-md px-2 md:px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <select
                                    name="serviceRequestStatusIdss"
                                    id="serviceRequestStatusIdss"
                                    value={filterData.serviceRequestStatusIdss}
                                    onChange={handleServiceRequestStatusIdChange}
                                    className="border border-gray-300 w-full md:w-fit rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="">Select Status</option>
                                    {statuses.map((status) => (
                                        <option
                                            key={status.serviceRequestStatusId}
                                            value={status.serviceRequestStatusId}
                                        >
                                            {status.serviceRequestStatus}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    onClick={handleSearch}
                                    className="bg-blue-500 hover:bg-blue-600 w-full md:w-fit text-white px-4 py-2 rounded-md"
                                >
                                    Search
                                </button>
                                {clearBtnshow && (
                                    <button
                                        onClick={clearFilters}
                                        className="bg-transparent border-2 border-gray-100 hover:bg-gray-50 w-full md:w-fit flex-1 md:block px-4 py-2 rounded-md text-center text-black"
                                        title="Clear Filter"
                                    >
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th
                                            onClick={() => handleSort('requestedClientName')}
                                            className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider cursor-pointer whitespace-nowrap"
                                        >
                                            Client Name <AiOutlineSortAscending className="inline" />
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Client Address</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Service Name</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Required Date</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Status</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {mergedFilteredDatas.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : (
                                        mergedFilteredDatas.map((item) => (
                                            <tr key={item.serviceRequestId} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.requestedClientName}</td>
                                                <td className="px-6 py-4 text-sm text-gray-900">
                                                    {item.requestedClientAddress
                                                        ?.match(/.{1,20}/g) // splits the string into chunks of 1 to 20 characters
                                                        .map((line, index) => (
                                                            <div key={index}>{line}</div>
                                                        ))}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.serviceTypeName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formattedDate(item.requiredDate)}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.serviceRequestStatusName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
                                                    {(roleId === 1001 || roleId === 1002) && (
                                                        <Link to={`/assign-vendor/${item.serviceRequestId}`}>
                                                            <GrStatusInfo className="text-blue-500 hover:text-blue-700" title="Assign Vendor" />
                                                        </Link>
                                                    )}
                                                    <button
                                                        className="text-blue-500 hover:text-blue-700"
                                                        onClick={() => handleViewIconClick(item.serviceRequestId)}
                                                        title="View Service"
                                                    >
                                                        <Eye size={18} />
                                                    </button>
                                                    <button
                                                        className="text-gray-500 hover:text-gray-700"
                                                        onClick={() => handleEditIconClick(item.serviceRequestId)}
                                                        title="Edit Service"
                                                    >
                                                        <Pencil size={18} />
                                                    </button>
                                                    {/* <button
                                                        className="text-red-500 hover:text-red-700"
                                                        onClick={() => handleDeleteIconClick(item.serviceRequestId)}
                                                        title="Delete Service"
                                                    >
                                                        <Trash2 size={18} />
                                                    </button> */}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Service Request Modal */}
            <GlassmorphicModal
                isOpen={showAddForm}
                onClose={handleAddFormToggle}
                title="Service Request"
                size="lg"
                footer={addModalFooter}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {roleId !== 1003 && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Service Requested For <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="requestedClientId"
                                value={serviceRequestData.requestedClientId}
                                onChange={handleChange}
                                className={`w-full rounded-md border ${serviceRequestErrors.requestedClientId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                readOnly={roleId === 1003}
                            >
                                <option value="">Select Client</option>
                                {clients.map((client) => (
                                    <option key={client.clinetId} value={client.clinetId}>
                                        {client.firstName}
                                    </option>
                                ))}
                            </select>
                            {serviceRequestErrors.requestedClientId && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.requestedClientId}</p>}
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Service Request Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="serviceTypeId"
                            value={serviceRequestData.serviceTypeId}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${serviceRequestErrors.serviceTypeId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select Service Request</option>
                            {serviceTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {serviceRequestErrors.serviceTypeId && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.serviceTypeId}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Required Date <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="date"
                            name="requiredDate"
                            value={serviceRequestData.requiredDate ? serviceRequestData.requiredDate.split("T")[0] : ""}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${serviceRequestErrors.requiredDate ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            min={new Date().toISOString().split("T")[0]}
                        />
                        {serviceRequestErrors.requiredDate && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.requiredDate}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Description <span className="text-red-500">*</span>
                        </label>
                        <input
                            name="description"
                            type="text"
                            value={serviceRequestData.description}
                            onChange={handleChange}
                            maxLength={200}
                            className={`w-full rounded-md border ${serviceRequestErrors.description ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {serviceRequestErrors.description && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.description}</p>}
                    </div>
                </div>
                <div className="text-sm text-red-500 mt-4">* indicates required field</div>
            </GlassmorphicModal>

            {/* Edit Service Request Modal */}
            <GlassmorphicModal
                isOpen={showEditForm}
                onClose={() => setShowEditForm(false)}
                title="Edit Service Request"
                size="lg"
                footer={editModalFooter}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Service Request Type</label>
                        <input
                            value={serviceTypes.find(
                                (type) => type.id === serviceRequestData.serviceTypeId
                            )?.name || ""}
                            className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Document</label>
                        {serviceRequestData.docUrl ? (
                            getFileDisplay(serviceRequestData.docUrl)?.element
                        ) : (
                            <div className="w-20 h-20 border rounded flex items-center justify-center bg-gray-100">
                                <File size={24} className="text-gray-400" />
                                <span className="text-xs text-gray-500 ml-1">No File</span>
                            </div>
                        )}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Description <span className="text-red-500">*</span>
                        </label>
                        <input
                            name="description"
                            type="text"
                            value={serviceRequestData.description}
                            onChange={handleChange}
                            maxLength={200}
                            className={`w-full rounded-md border ${serviceRequestErrors.description ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {serviceRequestErrors.description && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.description}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Required Date <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="date"
                            name="requiredDate"
                            value={
                                serviceRequestData.requiredDate
                                    ? serviceRequestData.requiredDate.split("T")[0]
                                    : ""
                            }
                            onChange={handleChange}
                            className={`w-full rounded-md border ${serviceRequestErrors.requiredDate ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {serviceRequestErrors.requiredDate && <p className="text-red-500 text-xs mt-1">{serviceRequestErrors.requiredDate}</p>}
                    </div>

                    {roleId !== 1003 && (
                        <>
                            {sid === 58119 && (
                                <>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Service Charge <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            name="serviceCharge"
                                            type="text"
                                            value={serviceRequestData.serviceCharge}
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Invoice No <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            name="invoiceNo"
                                            type="text"
                                            value={serviceRequestData.invoiceNo}
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Service Request Status <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="serviceRequestStatusId"
                                            value={serviceRequestData.serviceRequestStatusId}
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="">Select Service Request Status</option>
                                            {statuses
                                                .filter(status => status.serviceRequestStatusId !== 58117) // Filter out the option with ID 58117
                                                .map(status => (
                                                    <option
                                                        key={status.serviceRequestStatusId}
                                                        value={status.serviceRequestStatusId}
                                                    >
                                                        {status.serviceRequestStatus}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    <>
                        {roleId === 1003 && (
                            <>
                                {sid === 58117 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Service Request Status <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="serviceRequestStatusId"
                                            value={serviceRequestData.serviceRequestStatusId}
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="">Select Service Request Status</option>
                                            {statuses
                                                .filter(status => status.serviceRequestStatusId !== 69471 && status.serviceRequestStatusId !== 58119)
                                                .map(status => (
                                                    <option
                                                        key={status.serviceRequestStatusId}
                                                        value={status.serviceRequestStatusId}
                                                    >
                                                        {status.serviceRequestStatus}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                </div>
                <div className="text-sm text-red-500 mt-4">* indicates required field</div>
            </GlassmorphicModal>

            {/* View Service Request Modal */}
            <GlassmorphicModal
                isOpen={selectedServiceRequest !== null}
                onClose={() => setSelectedServiceRequest(null)}
                title="Service Request Details"
                size="lg"
                footer={viewModalFooter}
            >
                {selectedServiceRequest && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Service Type</label>
                            <input
                                value={
                                    serviceTypes.find(
                                        (type) =>
                                            type.id === selectedServiceRequest.serviceTypeId
                                    )?.name || ""
                                }
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Access Code</label>
                            <input
                                value={selectedServiceRequest.vendorAccessCode}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Authentication Code</label>
                            <input
                                value={selectedServiceRequest.authenticationCode}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Service Charge</label>
                            <input
                                value={selectedServiceRequest.serviceCharge}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <input
                                value={selectedServiceRequest.description}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Required Date</label>
                            <input
                                value={formattedDate(selectedServiceRequest.requiredDate)}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                readOnly
                            />
                        </div>
                    </div>
                )}
            </GlassmorphicModal>

            {/* Delete Confirmation Modal */}
            <GlassmorphicModal
                isOpen={showDeleteConfirm}
                onClose={handleDeleteCancel}
                title="Confirm Delete"
                size="sm"
                footer={deleteModalFooter}
            >
                <p className="text-gray-700">
                    Are you sure you want to delete this service request? This action cannot be undone.
                </p>
            </GlassmorphicModal>
        </div>
    );
};

export default ServiceRequest;